<template>
  <div class="text-13 h-6 flex items-center">Text Generation</div>
</template>

<script>
export default {
  name: 'AITextGenerationOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    payload() {
      return this.item.payload;
    },
    variable() {
      return this.payload.variable;
    },
    value() {
      return this.payload.value;
    },
  },
};
</script>
